module.exports = __webpack_public_path__ + "media/cyclesTile@sm-fab3061d1edce65eacd076239d5a9657.jpg";